export class Region {
		public id?: number = 0
		public name: string = ''
		public color: string = ''
		public coordinates: Array<google.maps.LatLng> = []
		public companyId?: string = ''
}
